import { Row } from '../grid';
export default Row;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/row/index.js
// module id = 332
// module chunks = 3